import React from 'react';
import {
  Container,
  Typography,
  Box,
  Grid,
  Card,
  CardContent,
  CardActionArea,
} from '@mui/material';
import marketingTheme from '../themes/marketingTheme';
import { Link } from 'react-router-dom';

const ServicesOverview = () => {
  const services = [
    {
      title: "Machine Learning Consulting",
      icon: "🤖",
      url: "/services/machine-learning-consulting",
      description: "Transform your data into actionable insights with custom ML solutions."
    },
    {
      title: "Robotics Consulting",
      icon: "🦾",
      url: "/services/robotics-consulting",
      description: "Make robots smarter through advanced perception and learning algorithms."
    },
    {
      title: "Cyber-Physical Systems",
      icon: "🔗",
      url: "/services/cyber-physical-systems",
      description: "Bridge physical operations and digital operations for real-time insights."
    },
    {
      title: "Computer Vision",
      icon: "👁️",
      url: "/product/overview",
      description: "Advanced vision AI for industrial productivity and safety monitoring."
    }
  ];

  return (
    <Box sx={{ backgroundColor: '#24242a', minHeight: '100vh', color: 'white', pt: 10 }}>
      {/* Hero Section */}
      <Container maxWidth="lg" sx={{ py: 8 }}>
        <Box sx={{ textAlign: 'center', mb: 8 }}>
          <Typography
            variant="h2"
            component="h1"
            sx={{
              fontWeight: 'bold',
              mb: 3,
              color: 'white',
            }}
          >
            Services
          </Typography>
          <Typography
            variant="h5"
            sx={{
              color: 'rgba(255, 255, 255, 0.7)',
              maxWidth: '600px',
              mx: 'auto',
              lineHeight: 1.6,
            }}
          >
            Let us help you set and reach your automation goals.
          </Typography>
        </Box>

        {/* Services Grid */}
        <Box sx={{ mb: 8 }}>
          <Typography
            variant="h3"
            component="h2"
            sx={{
              fontWeight: 'bold',
              mb: 6,
              textAlign: 'center',
              color: marketingTheme.palette.primary.main,
            }}
          >
            Services We Offer
          </Typography>

          <Grid container spacing={4}>
            {services.map((service, index) => (
              <Grid item xs={12} sm={6} md={3} key={index}>
                <Card
                  component={Link}
                  to={service.url}
                  sx={{
                    backgroundColor: '#2d2d33',
                    border: '1px solid rgba(255, 255, 255, 0.1)',
                    height: '100%',
                    transition: 'all 0.3s ease',
                    textDecoration: 'none',
                    '&:hover': {
                      transform: 'translateY(-8px)',
                      borderColor: marketingTheme.palette.primary.main,
                      boxShadow: '0 8px 32px rgba(237, 185, 46, 0.2)',
                    },
                  }}
                >
                  <CardActionArea sx={{ height: '100%' }}>
                    <CardContent
                      sx={{
                        p: 4,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        textAlign: 'center',
                        height: '100%',
                      }}
                    >
                      <Box
                        sx={{
                          fontSize: '3rem',
                          mb: 2,
                        }}
                      >
                        {service.icon}
                      </Box>
                      <Typography
                        variant="h5"
                        component="h3"
                        sx={{
                          fontWeight: 'bold',
                          mb: 2,
                          color: 'white',
                        }}
                      >
                        {service.title}
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          color: 'rgba(255, 255, 255, 0.7)',
                          lineHeight: 1.6,
                        }}
                      >
                        {service.description}
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>

        {/* Additional Information */}
        <Box sx={{ textAlign: 'center', py: 8 }}>
          <Typography
            variant="h4"
            component="h2"
            sx={{
              fontWeight: 'bold',
              mb: 4,
              color: marketingTheme.palette.primary.main,
            }}
          >
            Why Choose Our Services?
          </Typography>
          
          <Grid container spacing={4} sx={{ mt: 4 }}>
            <Grid item xs={12} md={4}>
              <Box>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 'bold',
                    mb: 2,
                    color: 'white',
                  }}
                >
                  Expert Knowledge
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    color: 'rgba(255, 255, 255, 0.7)',
                    lineHeight: 1.6,
                  }}
                >
                  Deep expertise in machine learning, robotics, and industrial automation with proven track record.
                </Typography>
              </Box>
            </Grid>
            
            <Grid item xs={12} md={4}>
              <Box>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 'bold',
                    mb: 2,
                    color: 'white',
                  }}
                >
                  Custom Solutions
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    color: 'rgba(255, 255, 255, 0.7)',
                    lineHeight: 1.6,
                  }}
                >
                  Tailored approaches designed specifically for your industry needs and operational requirements.
                </Typography>
              </Box>
            </Grid>
            
            <Grid item xs={12} md={4}>
              <Box>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 'bold',
                    mb: 2,
                    color: 'white',
                  }}
                >
                  End-to-End Support
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    color: 'rgba(255, 255, 255, 0.7)',
                    lineHeight: 1.6,
                  }}
                >
                  From initial consultation to implementation and ongoing support, we're with you every step.
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </Box>
  );
};

export default ServicesOverview;
